import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import {Container,Grid,TextField,InputLabel,
    Typography,Button,InputBase ,IconButton ,
    Paper,Autocomplete,CircularProgress  } from '@mui/material';
// import textinput from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import axios from 'axios'
import { listSuplier } from '../actions/suplierActions'
import DateTimePicker from '@mui/lab/DateTimePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { makeStyles } from '@mui/styles';
import {AddCircle,Check,Search} from '@mui/icons-material';
import NumberFormat from 'react-number-format';
import DataTable, { ExpanderComponentProps }  from 'react-data-table-component';


const useStyles = makeStyles({

    btn_adr: {
      // background: (props) =>
      //   props.color === 'red'
      //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
      //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
      background :'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
      border: 0,
      borderRadius: 3,
      // boxShadow: (props) =>
      //   props.color === 'red'
      //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
      //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
      boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
      color: 'white',
      height: 48,
      padding: '0 30px',
      margin: 8,
    },
    btn_adr1: {
      // background: (props) =>
      //   props.color === 'red'
      //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
      //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
      background :'linear-gradient(to right, #ec008c, #fc6767);',
      border: 0,
      borderRadius: 3,
      // boxShadow: (props) =>
      //   props.color === 'red'
      //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
      //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
      boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
      color: 'white',
      height: 48,
      padding: '0 30px',
      margin: 8,
    },
    btn_lunada: {
      // background: (props) =>
      //   props.color === 'red'
      //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
      //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
      background :'linear-gradient(to right, #5433ff, #20bdff, #a5fecb);',
      border: 0,
      borderRadius: 50,
      // boxShadow: (props) =>
      //   props.color === 'red'
      //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
      //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
      boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
      color: 'white',
      // height: 48,
      padding: '5px 5px 5px 5px ',
      margin: 8,
    },
    btn_ijo_nom: {
        // background: (props) =>
        //   props.color === 'red'
        //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
        //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        background :'linear-gradient(to right, #b3ffab, #12fff7);',
        border: 0,
        borderRadius: 50,
        // boxShadow: (props) =>
        //   props.color === 'red'
        //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
        //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
        boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
        color: 'white',
        // height: 48,
        padding: '5px 5px 5px 5px ',
        margin: 8,
      },
    btn_add: {
        // background: (props) =>
        //   props.color === 'red'
        //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
        //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        background :'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%);',
        border: 0,
        borderRadius: 50,
        // boxShadow: (props) =>
        //   props.color === 'red'
        //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
        //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
        boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
        color: 'white',
        // height: 48,
        padding: '5px 5px 5px 5px ',
        margin: 8,
      },

      btn_save: {
        // background: (props) =>
        //   props.color === 'red'
        //     ? 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
        //     : 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        background :'linear-gradient(to right, #4776e6, #8e54e9);',
        border: 0,
        borderRadius: 50,
        // boxShadow: (props) =>
        //   props.color === 'red'
        //     ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
        //     : '0 3px 5px 2px rgba(33, 203, 243, .3)',
        boxShadow:'0 3px 5px 2px rgba(33, 203, 243, .3)',
        color: 'white',
        // height: 48,
        padding: '5px 5px 5px 5px ',
        margin: 8,
      },

  
  });



const DeliveryInNote = () => {
    const classes = useStyles();
    const [suplier, setsuplier] = useState()
    const [potxt, setpotxt] = useState('')
    const [billnotxt,setbillnotxt] = useState('')
    const [gudang, setgudang] = useState('')
    const [tgl, settgl] = useState(new Date())
    const [expire_date, setexpire_date] = useState(new Date().setFullYear(new Date().getFullYear() + 1))
    const [Payment_type,setPayment_type] = useState( {id: 1, label: 'TUNAI..'})
    const [Gross_amount, setGross_amount] = useState(0)
    const [Price_discount, setPrice_discount] = useState()
    const [Price_discountp, setPrice_discountp] = useState()
    const [Price_subtotal, setPrice_subtotal] = useState(0)
    const [Price_taxp, setPrice_taxp] = useState(0)
    const [Price_tax, setPrice_tax] = useState(0)
    const [ProductID, setProductID] = useState()
    const [qty, setqty] = useState(0)
    const [Qty_satuan_besar, setQty_satuan_besar] = useState(0)
    const [Qty_conversi, setQty_conversi] = useState(1)
    const [Id_satuan_besar, setId_satuan_besar] = useState(0)
    const [Disc, setDisc] = useState(0)
    const [Discp, setDiscp] = useState(0)
    const [Disc_price,setDisc_price] = useState(0)
    const [Discp_price,setDiscp_price]= useState(0)
    const [Discp_tot_price, setDiscp_tot_price] = useState(0)
    const [Vat_p, setVat_p] = useState(0)
    const [Vat_p_product, setVat_p_product] = useState(0)
    const [Vat_p_price, setVat_p_price] = useState(0)
    const [Vat_p_tot_price, setVat_p_tot_price] = useState(0)
    const [Vat, setVat] = useState(0)
    const [Harga, setHarga] = useState(0)
    const [Harga_satuan_besar, setHarga_satuan_besar] = useState(0)
    const [Harga_final, setHarga_final] = useState(0)
    const [Gross_amountProduct, setGross_amountProduct] = useState(0)
    const [Ket, setKet] = useState(0)
    const [Sub_total_final, setSub_total_final] = useState(0)
    const [Id_cur, setId_cur] = useState({value: 1, label: 'IDR'})
    const [Rate_cur, setRate_cur] = useState(1)

    const [Batch, setBatch] = useState()
    const [Serial_no, setSerial_no] = useState()


    const [ProductData, setProductData] = useState([])

    
useEffect(
    () => {
      // console.log(inputValue);
      // console.log(ProcesHarga);
      // let ProcesHarga = qty * inputValue.value ; 
      setHarga(parseFloat(Harga_satuan_besar)/parseFloat(Qty_conversi));
      setqty(parseFloat(Qty_satuan_besar) * parseFloat(Qty_conversi));
      let nom_discp = (((parseFloat(Discp) * 0.01)*parseFloat(Harga))  + (parseFloat(Disc)/parseFloat(Qty_conversi)));
        //   console.log("nom_discp "+nom_discp);
      let nom_vat = (((parseFloat(Vat_p) * 0.01)* parseFloat(Harga))  + (parseFloat(Vat)/parseFloat(Qty_conversi)))
        //   console.log("nom_vat "+nom_vat);
      let harga_final = (((parseFloat(Harga) + parseFloat(nom_vat)) - parseFloat(nom_discp)) *parseFloat(Rate_cur))
        //   console.log("hj "+harga_final );
      setHarga_final(harga_final);
      let tot_harga_final = (parseFloat(harga_final) * parseFloat(qty));
      setSub_total_final(tot_harga_final);
      let tot_gross = (parseFloat(Harga) * parseFloat(qty))
      setGross_amountProduct(tot_gross);
      setDisc_price(((parseFloat(Disc)/parseFloat(Qty_conversi)) * parseFloat(qty)))
      setDiscp_price(((parseFloat(Discp) * 0.01) * parseFloat(Harga)))
      setDiscp_tot_price((((parseFloat(Discp) * 0.01) * parseFloat(Harga)) * parseFloat(qty)))
      setVat_p_price( ((parseFloat(Vat_p) * 0.01) * parseFloat(Harga)))
      setVat_p_tot_price((((parseFloat(Vat_p) * 0.01) * parseFloat(Harga)) * parseFloat(qty)))


  }  

)
useEffect(
    () => {
    setPrice_subtotal(0)
    ProductData.map((i)=> (
        setPrice_subtotal(Price_subtotal +i.Sub_total_final)  
    ))
}
,[ProductData,Price_subtotal])

const adr_add =() => {

    //   setProductData(ProductData.dataProduct.push({adr:1,adr1:2}))
    setProductData(ProductData=> [...ProductData,
        {
            ProductID:ProductID,
            qty:qty,
            gudang:gudang,
            tgl:tgl,
            expire_date:expire_date,
            Qty_satuan_besar:Qty_satuan_besar,
            Qty_conversi:Qty_conversi,
            Id_satuan_besar:Id_satuan_besar,
            Disc:Disc,
            Discp:Discp,
            Discp_tot_price:Discp_tot_price,
            Disc_price:Disc_price,
            Vat_p:Vat_p,
            // Vat_p_product:Vat_p_product,
            Vat_p_price:Vat_p_price,
            Vat_p_tot_price:Vat_p_tot_price,
            Vat:Vat,
            Harga:Harga,
            Harga_satuan_besar:Harga_satuan_besar,
            Harga_final:Harga_final,
            Gross_amountProduct:Gross_amountProduct,
            Ket:Ket,
            Sub_total_final:Sub_total_final,
            Id_cur:Id_cur,
            Rate_cur:Rate_cur,
            Batch:Batch,
            Serial_no:Serial_no,
        }
    
    ])


}

const columns = [
    {
        name: 'Kode',
        selector: row => row.ProductID.code,
        sortable: true,
    },
    {
        name: 'Nama',
        selector: row => row.ProductID.label,
        sortable: true,
    },
    {
        name: 'Jumlah',
        selector: row => row.Qty_satuan_besar,
        sortable: true,
    },
    {
        name: 'Satuan',
        selector: row => row.Id_satuan_besar.label,
    },
    {
        name: 'Harga Beli',
        selector: row =>{
            return <NumberFormat
            thousandsGroupStyle="thousand"
            value={row.Harga_satuan_besar}
            prefix="Rp."
            decimalSeparator="."
            displayType="text"
            type="text"
            thousandSeparator={true}
            allowNegative={true} /> } ,
    },
    {
        name: 'Sub TOTAL',
        selector: row =>{
            return <NumberFormat
            thousandsGroupStyle="thousand"
            value={row.Gross_amountProduct}
            prefix="Rp."
            decimalSeparator="."
            displayType="text"
            type="text"
            thousandSeparator={true}
            allowNegative={true} /> } ,
    },
    {
        name: 'Diskon %',
        selector: row =>row.Discp,
    },
    {
        name: 'Nominal Diskon',
        selector: row =>{
            return <NumberFormat
            thousandsGroupStyle="thousand"
            value={row.Discp_tot_price}
            prefix="Rp."
            decimalSeparator="."
            displayType="text"
            type="text"
            thousandSeparator={true}
            allowNegative={true} /> }  ,
    },
    {
        name: 'HPP',
        selector: row =>{
            return <NumberFormat
            thousandsGroupStyle="thousand"
            value={row.Harga_final}
            prefix="Rp."
            decimalSeparator="."
            displayType="text"
            type="text"
            thousandSeparator={true}
            allowNegative={true} /> } ,
    },
    {
        name: 'Hna + PPN',
        selector: row =>{
            return <NumberFormat
            thousandsGroupStyle="thousand"
            value={row.Harga_final}
            prefix="Rp."
            decimalSeparator="."
            displayType="text"
            type="text"
            thousandSeparator={true}
            allowNegative={true} /> } ,
    },
    {
        name: 'Tgl Exp',
        selector: row => row.expire_date,
    },
    {
        name: 'TOTAL',
        selector: row =>{
            return <NumberFormat
            thousandsGroupStyle="thousand"
            value={row.Sub_total_final}
            prefix="Rp."
            decimalSeparator="."
            displayType="text"
            type="text"
            thousandSeparator={true}
            allowNegative={true} /> } ,
    },
];

    
    const promiseOptions = (inputValue,callback) => {

        axios.get(`http://localhost:8080/api/suplier_/cari/${inputValue}`).then(res => {
            const persons = res.data.data;
            callback(persons.map(i=> ({label:i.nama+"("+i.code+")",id:i.ID})))
          })

    }

    const cariGudang = (inputValue,callback) => {

        axios.get(`http://localhost:8080/api/gudang_/cari/${inputValue}`).then(res => {
            const gd = res.data.data;
            callback(gd.map(i=> ({label:i.nama+"("+i.code+")",id:i.ID})))
          })
    }

    const cariCur= (inputValue,callback) => {

        axios.get(`http://localhost:8080/api/cur_/cari/${inputValue}`).then(res => {
            const data = res.data.data;
            callback(data.map(i=> ({label:i.nama+"("+i.code+")",id:i.ID})))
          })
    }

    
    const cariBarangSelect = (inputValue,callback) => {
        axios.get(`http://localhost:8080/api/product_/cari/${inputValue}`).then(res => {
            const product = res.data.data;
            callback(product.map(i=> ({label:i.name+"("+i.code+")",id:i.ID,code:i.code})))
          })
    }

    const cariSatuanSelect = (inputValue,callback) => {
        axios.get(`http://localhost:8080/api/unit_/cari/${inputValue}`).then(res => {
            const data = res.data.data;
            callback(data.map(i=> ({label:i.nama+"("+i.code+")",id:i.ID,qty:i.qty_conversi,})))
          })
    }

    const getDataSatuan = (id_satuan) => {
        axios.get(`http://localhost:8080/api/unit_/${id_satuan}`).then(res => {
            const data = res.data.data;
            console.log(res)
          })
    }

   
      


    return (
        <Container sx={{ mt: 9 }} >
            <Card sx={{borderRadius: 3 ,boxShadow: 10}}>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        Pembelian
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField sx={{mt:3}}
                                size="small"
                                fullWidth={true}
                                id="potxt" 
                                label="Po No." 
                                variant="outlined"
                                value={potxt}
                                onChange={(e) => setpotxt(e.target.value)}  />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel shrink htmlFor="bootstrap-input">
                                Suplier
                            </InputLabel>
                            <AsyncSelect
                                value={suplier}
                                // onChange={this.onChange}
                                onChange={(e) => setsuplier(e)} 
                                placeholder={'Pilih Suplier'}
                                loadOptions={promiseOptions}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField sx={{mt:3}}
                                size="small"
                                fullWidth={true}
                                id="fakturtxt"
                                label="No Faktur"
                                variant="outlined"
                                value={billnotxt}
                                onChange={(e) => setbillnotxt(e.target.value)}  />
                        </Grid>
                        <Grid item xs={6}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            Gudang
                        </InputLabel>
                            <AsyncSelect
                                value={gudang}
                                // onChange={this.onChange}
                                onChange={(e) => setgudang(e)} 
                                placeholder={'Pilih Gudang'}
                                loadOptions={cariGudang}
                            />
                        </Grid>

                        <Grid item xs={6} >
                            <LocalizationProvider  dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                sx={{mt:3}}
                                // readOnly={true}
                                fullWidth={true}
                                label="Tanggal"
                                value={tgl}
                                onChange={(e) => settgl(e.value)}
                                renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            Jenis Bayar
                        </InputLabel>
                            <AsyncSelect
                                value={Payment_type}
                                // onChange={this.onChange}
                                onChange={(e) => setPayment_type(e)} 
                                placeholder={'Jenis'}
                                loadOptions={cariGudang}
                            />
                        </Grid>
                    </Grid>
                    <Button sx={{m:1}} variant="contained" className={classes.btn_add} startIcon={<AddCircle />} onClick={()=>{
                        console.log(ProductData)
                    }}>
                        Item
                    </Button>
                    <Button sx={{m:1}}  variant="contained" className={classes.btn_save} startIcon={<Check />} onClick={()=>{adr_add(); }}>
                        Save
                    </Button>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            {/* <TextField sx={{mt:3}}
                                disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="Price_subtotaltxt" 
                                label="Total." 
                                variant="outlined"
                                value={Price_subtotal}
                                onChange={(e) => setPrice_subtotal(e.target.value)}  /> */}
                            <NumberFormat
                                sx={{mt:3,mb:2}}
                                customInput={TextField}
                                disabled
                                defaultValue={0}
                                fullWidth={true}
                                id="Price_subtotaltxt"
                                label="Total"
                                size="small"
                                // variant="standard"
                                thousandsGroupStyle="thousand"
                                value={Price_subtotal}
                                prefix="Rp."
                                decimalSeparator="."
                                displayType="input"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true} />

                        </Grid>
                        <Grid item xs={2}>
                            <TextField sx={{mt:3}}
                                disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="Price_discountptxt" 
                                label="Diskon%." 
                                variant="outlined"
                                value={Price_discountp}
                                onChange={(e) => setPrice_discountp(e.target.value)}  />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField sx={{mt:3}}
                                disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="Price_discounttxt" 
                                label="Diskon." 
                                variant="outlined"
                                value={Price_discount}
                                onChange={(e) => setPrice_discount(e.target.value)}  />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField sx={{mt:3}}
                                disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="Price_taxptxt" 
                                label="Pajak %." 
                                variant="outlined"
                                value={Price_taxp}
                                onChange={(e) => setPrice_taxp(e.target.value)}  />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField sx={{mt:3}}
                                disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="Price_taxtxt" 
                                label="Pajak." 
                                variant="outlined"
                                value={Price_tax}
                                onChange={(e) => setPrice_tax(e.target.value)}  />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Card sx={{borderRadius: 3 ,boxShadow: 10}}>
                <CardContent>
                    
                    <Grid container spacing={2}>
                        {/* <Grid item xs={6}>
                            <Paper component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                            >
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Cari Barang"
                                inputProps={{ 'aria-label': 'Cari Barang' }}
                            />
                            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                <Search />
                            </IconButton>
                        </Paper>
                        </Grid> */}
                        <Grid item xs={8}></Grid>
                        <Grid item xs={4}>
                            <NumberFormat
                                sx={{mt:3,mb:2}}
                                customInput={TextField}
                                disabled
                                defaultValue={0}
                                fullWidth={true}
                                id="Sub_total_finaltxt"
                                label="Total Harga"
                                variant="standard"
                                thousandsGroupStyle="thousand"
                                value={Sub_total_final}
                                prefix="Rp."
                                decimalSeparator="."
                                displayType="input"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true} />
                        </Grid>
                        <Grid item xs={6}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            Pilih Barang..
                        </InputLabel>
                            <AsyncSelect
                                value={ProductID}
                                // onChange={this.onChange}
                                onChange={(e) => setProductID(e)}
                                placeholder={'Cari Barang..'}
                                loadOptions={cariBarangSelect}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel shrink htmlFor="bootstrap-input">
                                Pilih Satuan
                            </InputLabel>
                            <AsyncSelect
                                value={Id_satuan_besar}
                                // onChange={this.onChange}
                                onChange={(e) =>{
                                    
                                    setId_satuan_besar(e)
                                    setQty_conversi(e.qty)
                                    // getDataSatuan(e.id)
                                    // console.log(Id_satuan_besar.value)
                                }}
                                placeholder={'Pilih Satuan..'}
                                loadOptions={cariSatuanSelect}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            {/* <TextField sx={{mt:3}}
                                // disabled
                                // defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="qtytxt" 
                                label="Qty.." 
                                variant="outlined"
                                value={qty}
                                onChange={(e) => setqty(e.target.value), () => {
                                    hitungHarga(); }}  /> */}
                                <NumberFormat
                                    sx={{mt:3}}
                                    customInput={TextField}
                                    defaultValue={0}
                                    id="qtytxt" 
                                    label="Qty.." 
                                    size="small"
                                    fullWidth={true}
                                    thousandsGroupStyle="thousand"
                                    value={Qty_satuan_besar}
                                    // onChange={(e) => hitungHarga(e.target.value)}
                                    onValueChange={(values) =>
                                            setQty_satuan_besar(values.value)
                                    }
                                    // prefix="Rp."
                                    decimalSeparator="."
                                    displayType="input"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false} />
                                    
                        </Grid>
                        
                        <Grid item xs={2}>
                            {/* <TextField sx={{mt:3}}
                                // disabled
                                defaultValue="0"
                                size="small"
                                fullWidth={true}
                                id="hargatxt"
                                label="Harga.."
                                variant="outlined"
                                
                                value={Harga}
                                onChange={(e) => setHarga(e.target.value)}  /> */}
                            <NumberFormat
                                sx={{mt:3}}
                                customInput={TextField}
                                defaultValue={0}
                                id="hargatxt"
                                label="Harga.."
                                size="small"
                                fullWidth={true}
                                thousandsGroupStyle="thousand"
                                value={Harga_satuan_besar}
                                onValueChange={(values) =>
                                    setHarga_satuan_besar(values.value)
                                }
                                prefix="Rp."
                                decimalSeparator="."
                                displayType="input"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={false} />
                        </Grid>
                        <Grid item xs={2}>
                            <InputLabel shrink htmlFor="bootstrap-input">
                                Currencys...
                            </InputLabel>
                            <AsyncSelect
                                value={Id_cur}
                                // onChange={this.onChange}
                                onChange={(e) => setId_cur(e)}
                                placeholder={'Cari Currency..'}
                                // loadOptions={cariCur}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <TextField 
                                sx={{mt:3}}
                                // disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="discptxt"
                                label="Disc %.."
                                variant="outlined"
                                value={Discp}
                                onChange={(e) =>setDiscp(e.target.value)
                                        }
                                        
                                        />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField 
                                sx={{mt:3}}
                                // disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="disctxt"
                                label="Potongan"
                                variant="outlined"
                                value={Disc}
                                onChange={(e) =>setDisc(e.target.value)}
                                        
                                        />
                        </Grid>
                        <Grid item xs={1}>
                            <TextField 
                                sx={{mt:3}}
                                // disabled
                                defaultValue={0}
                                size="small"
                                fullWidth={true}
                                id="vat_ptxt"
                                label="Vat %.."
                                variant="outlined"
                                value={Vat_p}
                                onChange={(e) =>setVat_p(e.target.value)}
                                        
                                        />
                        </Grid>
                        <Grid item xs={2}>
                            {/* <TextField 
                                sx={{mt:3}}
                                disabled
                                defaultValue="0"
                                size="small"
                                fullWidth={true}
                                id="Harga_finaltxt"
                                label="Harga Jadi"
                                variant="outlined"
                                value={Harga_final}
                                onChange={(e) => setHarga_final(e.target.value)}  /> */}
                                <NumberFormat
                                    sx={{mt:3}}
                                    customInput={TextField}
                                    disabled
                                    defaultValue={0}
                                    size="small"
                                    fullWidth={true}
                                    id="Harga_finaltxt"
                                    label="Harga Jadi"
                                    thousandsGroupStyle="thousand"
                                    value={Harga_final}
                                    prefix="Rp."
                                    decimalSeparator="."
                                    displayType="input"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true} />
                        </Grid>
                        
                        <Grid item xs={2}>
                            <TextField 
                                sx={{mt:3}}
                                // disabled
                                defaultValue={"-"}
                                size="small"
                                fullWidth={true}
                                id="batchtxt"
                                label="Batch.."
                                variant="outlined"
                                value={Batch}
                                onChange={(e) =>setBatch(e.target.value)
                                        }/>
                        </Grid>
                        <Grid item xs={2}>
                            <TextField 
                                sx={{mt:3}}
                                // disabled
                                defaultValue={"-"}
                                size="small"
                                fullWidth={true}
                                id="Serial_notxt"
                                label="Serial no.."
                                variant="outlined"
                                value={Serial_no}
                                onChange={(e) =>setSerial_no(e.target.value)
                                        } />
                        </Grid>
                        <Grid item xs={6} >
                            <LocalizationProvider  dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                sx={{mt:3}}
                                // readOnly={true}
                                fullWidth={true}
                                label="Kadaluarsa"
                                value={expire_date}
                                onChange={(e) => setexpire_date(e.value)}
                                renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Button sx={{m:2}}  variant="contained" className={classes.btn_save} startIcon={<Check />} onClick={()=>{adr_add(); }}>
                            Input
                        </Button>
                    </Grid>
                </CardContent>
            </Card>
            <Card sx={{borderRadius: 3 ,boxShadow: 10}}>
            <CardContent>
                <DataTable
                defaultSortFieldId={1}
                columns={columns}
                data={ProductData}
                // pagination 
                fixedHeader
                fixedHeaderScrollHeight="600px"
                // expandableRows
                // expandableRowsComponent={ExpandedComponent}
                />
            </CardContent>
            </Card>                           
            
            
            
        </Container>
        

            

    )
}

export default DeliveryInNote
